import { SITE } from '@/app/constants';
import type { I18nRecord } from '@/app/types';

// 统一的下载页面链接
export const DOWNLOAD_URL = SITE === 'china' ? 'https://www.vidu.cn/app-download' : 'https://www.vidu.com/app-download';

// 生产环境APP下载地址
export const GO_VIDU_APP_HOST = SITE === 'china' ? 'go.vidu.cn/app' : 'go.vidu.com/app';

// 开发环境APP下载地址
export const GO_VIDU_APP_URL = SITE === 'china' ? 'https://www.pgyer.com/viduAI' : 'https://www.pgyer.com/vidu';

export const TIPS_ZH = [
  'AI换装',
  'AI模板',
  '抽象整活',
  '热梗模仿',
  '角色扮演',
  '动画创作',
  '影视创作',
  '短剧制作',
  '电商广告',
  '二创整活',
  '品牌宣传',
  '创意MV',
  '自媒体内容',
];

export const TIPS: I18nRecord<string[]> = {
  china: {
    zh: TIPS_ZH,
  },
  global: {
    zh: TIPS_ZH,
    en: [
      'AI Dressing',
      'AI Templates',
      'Abstract Fun',
      'Hot Meme Imitation',
      'Role Play',
      'Animation Creation',
      'Film Creation',
      'Short Film Production',
      'E-commerce Advertising',
      '2D Animation',
      'Brand Promotion',
      'Creative MV',
      'Self-media Content',
    ],
    ja: [
      'AI Dressing',
      'AI Templates',
      'Abstract Fun',
      'Hot Meme Imitation',
      'Role Play',
      'Animation Creation',
      'Film Creation',
      'Short Film Production',
      'E-commerce Advertising',
      '2D Animation',
      'Brand Promotion',
      'Creative MV',
      'Self-media Content',
    ],
  },
};

export const TIPS_COLOR = [
  {
    bgColor: 'rgba(0,98,255,0.48)',
    color: '#8DC8FF',
  },
  {
    bgColor: 'rgba(97,208,117,0.48)',
    color: '#A1FFB2',
  },
  {
    bgColor: 'rgba(255,60,0,0.48)',
    color: '#FFA286',
  },
];
